import PageHeader from '../../components/PageHeader/PageHeader';
import Toolbar from '../../components/Toolbar/Toolbar';
import React, { useState, useEffect, useRef } from 'react'
import DataTable from 'react-data-table-component'
import { IoTrashOutline } from "react-icons/io5";
import { LuPencilLine } from "react-icons/lu";
import AgregarFFW from './AgregarFFW';
import EditarFFW from './EditarFFW';
import {urlApiProd} from '../utiles';

const FFW = () => {
    const [dataFFW, setDataFFW] = useState([]);
    const firstRender = useRef(true);
    const [showAgregar, setShowAgregar] = useState(false);
    const [showEditar, setShowEditar] = useState(false);
    const [selected, setSelected] = useState(null);
    const [filterText, setFilterText] = useState('');
    const [filteredData, setFilteredData] = useState([]);

    const fetchData = async () => {
        const token = localStorage.getItem('token');
        try {
            const ffwResponse = await fetch(`${urlApiProd}/ffw`, {
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            if (ffwResponse.status === 401) {
                throw new Error('Unauthorized');
            }
            const ffwData = await ffwResponse.json();
            setDataFFW(ffwData);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    }

    useEffect(() => {
        if (firstRender.current) {
            fetchData();
            firstRender.current = false;
        }
    }, []);

    useEffect(() => {
        if (Array.isArray(dataFFW)) {
            const filtered = dataFFW.filter((row) =>
                Object.values(row).some((value) =>
                    value.toString().toLowerCase().includes(filterText.toLowerCase())
                )
            );
            setFilteredData(filtered);
        }
    }, [dataFFW, filterText]);

    const columns = [
        {
            name: 'ID',
            selector: row => row.id_ffw
        },
        {
            name: 'Nombre',
            selector: row => row.nombre
        },
        {
            name: 'Acciones',
            cell: row => (
                <div className="d-flex gap-2">
                    <button onClick={() => handleEditar(row)} className="btn btn-sm btn-outline-warning">
                        <LuPencilLine />
                    </button>
                    <button onClick={() => handleEliminar(row.id_ffw)} className="btn btn-sm btn-outline-danger">
                        <IoTrashOutline />
                    </button>
                </div>
            ),
        },
    ]

    const handleAgregar = () => {
        setShowAgregar(true);
    }

    const handleEditar = (ffw) => {
        setSelected(ffw);
        setShowEditar(true);
    }

    const handleCloseEditar = () => {
        setSelected(null);
        setShowEditar(false);
    }

    const handleEliminar = (idAEliminar) => {
        const token = localStorage.getItem('token'); // Obtener token de autenticación
        fetch(`${urlApiProd}/deleteffw/${idAEliminar}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
        })
        .then(response => {
            if (response.ok) {
                alert('Datos Eliminados Correctamente.');
                fetchData();
            } else {
                alert('Error al intentar eliminar datos.');
            }
        })
        .catch(error => {
            console.error('Error de red:', error);
        });
    }

    return (
        <div className='container-fluid ui-page'>
            <PageHeader
                eyebrow="Registros"
                title="Freight Forwarders"
                descripcion="Registro de freight forwarders que gestionan el transporte de los embarques."
                actions={
                    <button type="button" className="ui-btn ui-btn-primary" onClick={handleAgregar}>Agregar FFW</button>
                }
            />
            <div className='card'>
                <div className='card-body mb-2'>
                    <Toolbar left={<input
                            type="text"
                            placeholder="Buscar..."
                            value={filterText}
                            onChange={(e) => setFilterText(e.target.value)}
                            className='form-control'
                        />} />
                    
                    {showAgregar && <AgregarFFW cerrar={()=>setShowAgregar(false)} />}
                    <div className='card'>
                        <div className='card-body'>
                            <DataTable
                                columns={columns}
                                data={filteredData}
                                noHeader
                                responsive
                                pagination
                                highlightOnHover
                            />
                        </div>
                    </div>
                    {selected && showEditar && (
                        <EditarFFW
                            ffw={selected}
                            cerrar={handleCloseEditar}
                        />
                    )}
                </div>
            </div>
        </div>
    )
}
export default FFW